import { Installed } from '../Installed';
import { jsx as _jsx } from "react/jsx-runtime";
export const getNoStatusesOptions = ({
  productType,
  showInstalledStatus
}) => {
  const content = showInstalledStatus ? /*#__PURE__*/_jsx(Installed, {
    productType: productType
  }) : null;
  return {
    content,
    ctaButton: null,
    popoverDisabled: true,
    popoverHeadingText: '',
    popoverMessage: ''
  };
};